module.exports = __webpack_public_path__ + "static/suedsee-f6d6a56c439c8dd8b31721f451ee3878.svg";